module.exports = __webpack_public_path__ + "img/xiazai.5cdc4d5f.png";